import { gql } from '@apollo/client';
import { Overage } from './fetch-overage-items';

const BlendedComputationDetails = gql`
  fragment BlendedComputationDetails on InvoiceMargins {
    blended
    blendedComputation {
      newGlp
      previousGlp
      upsellPercentage
      renewPercentage
      upsellValue
      renewalValue
      upsellMargin
      renewalMargin
      blendedMargin
    }
  }
`;

export const lineItemDetailsForInvoiceWithOverage = gql`
  ${Overage}
  ${BlendedComputationDetails}
  fragment lineItemDetailsForInvoiceWithOverage on InvoiceLineItems {
    id
    edition
    entitlementId
    entitlementNumber
    cloudSiteHostname
    amount
    subtotal
    description
    cloudSiteId
    platform
    productKey
    productName
    startDate
    invoiceLineItemId
    endDate
    originalInvoiceReferral {
      invoiceNumber
    }
    promotionItems {
      id
      title
      applicationReason {
        id
        readableName
        customisable {
          id {
            type
            anyOf {
              readableName
              id
            }
          }
        }
      }
      purpose {
        reasonCode
        name
        invoiceNote
      }
      benefits {
        duration
        benefitType
        subBenefitType
        value
        iterations
      }
      status
      eligibilityRules {
        currency
      }
    }
    discounts {
      amount
      type
      percent
      reason
      reasonCode
      promotionId
    }
    margins {
      type
      amount
      percent
      promotionId
      ...BlendedComputationDetails
    }
    entitlement {
      id
      entitlementNumber
      baseProduct
      cloudSiteId
      cloudSiteUrl
      accountId: orgId
      platform
      productId
      productName
      parentSen
      sourceSystem
      billingCycle
      billingStatus
      businessKey: id
      pricingPlanId
      offeringId
      isSandbox
      isAddOn
      scheduledChanges {
        chargeQuantities {
          chargeElement
          quantity
          lastUpdatedAt
          usersUpdate {
            isAdded
            isRemoved
            isCreated
            changeBy
          }
        }
      }
    }
    essotEntitlement {
      relatesFromEntitlements {
        entitlementId
        relationshipType
      }
      relatesToEntitlements {
        entitlementId
        relationshipType
      }
    }
    promotionIds
    quantity
    sen
    pricingPlanId
    orgInfo {
      orgId
      orgName
    }
    pricingPlan {
      type
      billingFrequency
      id
      currency
      pricingPlanType
      status
      description
      tiers {
        unitAmount
        flatAmount
        floor
        ceiling
      }
    }
    taxRate
    taxAmountPaymentCurrency
    taxItems {
      id
      taxPercent
      tax
      taxId
      taxAmountLabel
      taxIdLabel
    }
    latestInvoiceDetails {
      id
      invoiceNumber
    }
    logoId
    ...Overage
  }
`;

const productAppLineItemsWithOverage = gql`
  ${lineItemDetailsForInvoiceWithOverage}
  fragment productAppLineItemsWithOverage on ProductAppLineItem {
    products {
      ...lineItemDetailsForInvoiceWithOverage
    }
    apps {
      ...lineItemDetailsForInvoiceWithOverage
    }
    addOns @include(if: $fetchAddOns) {
      ...lineItemDetailsForInvoiceWithOverage
    }
  }
`;

export const coupledLineItemsOnInvoiceWithOverage = gql`
  ${productAppLineItemsWithOverage}
  fragment coupledLineItemsOnInvoiceWithOverage on ProductAppLineItemData {
    jira {
      ...productAppLineItemsWithOverage
    }
    confluence {
      ...productAppLineItemsWithOverage
    }
    statuspage {
      ...productAppLineItemsWithOverage
    }
    atlassianGuard @include(if: $fetchAGPAddon) {
      ...productAppLineItemsInPPC
    }
    other {
      ...productAppLineItemsWithOverage
    }
  }
`;
